import { Child } from 'pym.js';
import * as d3 from 'd3';
import meta from './data/meta.json';
import * as hashes from './data/hash-dict';

import Zion from './utils/Zion';

// polyfills
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/graphic.scss';

let latestData;

const mapboxgl = require('mapbox-gl');

const pkg = require('../package.json');

const ai2html = null;

const geojsonData = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-118.54453, 34.04022] },
      properties: {
        Name: 'Palisades Fire',
        TextAnchor: 'top-right',
      },
    },
    // {
    //   type: 'Feature',
    //   geometry: { type: 'Point', coordinates: [-118.13918, 34.1892] },
    //   properties: {
    //     Name: 'Eaton Fire',
    //     TextAnchor: 'left',
    //   },
    // },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-118.577867, 34.566841] },
      properties: {
        Name: 'Hughes Fire',
        TextAnchor: 'left',
      },
    },
    // {
    //   type: 'Feature',
    //   geometry: { type: 'Point', coordinates: [-119.059, 34.1655] },
    //   properties: {
    //     Name: 'Laguna Fire',
    //     TextAnchor: 'left',
    //   },
    // },


    // {
    //   type: 'Feature',
    //   geometry: { type: 'Point', coordinates: [-119.20224, 34.23661] },
    //   properties: { Name: 'Auto Fire' },
    // },
    // {
    //   type: 'Feature',
    //   geometry: { type: 'Point', coordinates: [-118.478134, 34.32533] },
    //   properties: {
    //     Name: 'Hurst Fire',
    //     TextAnchor: 'left',
    //   },
    // }
  ],
};

geojsonData.features = geojsonData.features.map(
  (d) => {
    d.properties.TextAnchor = (d.properties.Name === 'Sunset Fire') ? 'right' : 'left';
    return d;
  },
);


if (process.env.NODE_ENV === 'development') {

}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

let chartData;
let rawData;
let lastUpdated;


function draw() {
  if (process.env.NODE_ENV === 'development') {
  }
}

d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});


mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';

// const MAP_ID = 'mapbox://styles/cnndigital/clq432mvc019m01qm3htp3bre'
const MAP_ID = 'mapbox://styles/cnndigital/cl960ytee001215qu1uhorjlx';


const COLOR_LIMITED = '#FEEDCE';
const COLOR_MINOR = '#F8C153';
const COLOR_MODERATE = '#F18851';
const COLOR_MAJOR = '#C52622';
const COLOR_EXTREME = '#7C4EA5';

document.documentElement.style.setProperty('--color-0', COLOR_LIMITED);
document.documentElement.style.setProperty('--color-1', COLOR_MINOR);
document.documentElement.style.setProperty('--color-2', COLOR_MODERATE);
document.documentElement.style.setProperty('--color-3', COLOR_MAJOR);
document.documentElement.style.setProperty('--color-4', COLOR_EXTREME);

const LAYER_OPACITY = 1;

const state_hashes = hashes.default;
let mapParams;
let hasLocation;
let usingParentDotHtml = false;
let outageEvent;

// check for URL params
function checkParams(events) {
  // use the staging parent URL if we're in the CNN staging environment
  // otherwise use the straight url
  let url;
  if ((pymChild.parentUrl) && (pymChild.parentUrl.indexOf('/parent.html') !== -1)) {
    url = pymChild.parentUrl;
    usingParentDotHtml = true;
  } else {
    url = window.location.href;
  }

  // console.log('Parent url:', pymChild.parentUrl);
  // console.log('Using url:', url);

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  const splitMbhash = (text) => {
    let hasharray = [];
    hasharray = text.split('/').map(Number);

    // return the bearing as 0 if it's missing
    if (hasharray.length == 3) {
      hasharray[3] = 0;
    }
    return hasharray;
  };


  mapParams = getParams(url);
  if ('lnglat' in mapParams) {
    mapParams.lnglat = [parseFloat(mapParams.lnglat.split(',')[0]), parseFloat(mapParams.lnglat.split(',')[1])];
  }
  if ('z' in mapParams) {
    mapParams.z = parseFloat(mapParams.z);
  }
  if ('bearing' in mapParams) {
    mapParams.bearing = parseFloat(mapParams.bearing);
  }
  if ('state' in mapParams) {
    mapParams.mbhash = state_hashes[mapParams.state.toUpperCase()];
    // console.log('centered on ', mapParams.state.toUpperCase());
  }
  if ('event' in mapParams) {
    const find_event = events.filter(d => d.event_code == mapParams.event);

    if (find_event) {
      outageEvent = find_event[0];
    }

    if (outageEvent && outageEvent.map_view) {
      mapParams.mbhash = outageEvent.map_view;
      console.log('using event', mapParams.event);
    }
  }
  if ('mbhash' in mapParams) {
    const parsedHash = splitMbhash(mapParams.mbhash);
    mapParams.z = parsedHash[0];
    mapParams.lnglat = [parsedHash[2], parsedHash[1]];
    mapParams.bearing = parsedHash[3];
  }

  if (!('scale' in mapParams)) {
    mapParams.scale = 'high';
  }


  // Set params to true if they have what we want (zoom + lng/lat)
  hasLocation = !!('lnglat' in mapParams && 'z' in mapParams);
}

checkParams();

const mapBounds = [
  [-125.000000, 24.396308], // Southwest corner: [longitude, latitude]
  [-66.934570, 49.3457868], // Northeast corner: [longitude, latitude]
];


// screen size config
const optionsSm = {
  initZoom: 7,
  minZoom: 6,
  maxZoom: 15,
  center: [-118.4, 34.252091],
  mapBounds,
};


const optionsLg = {
  initZoom: 8,
  minZoom: 6,
  maxZoom: 15,
  center: [-118.4, 34.252091],
  mapBounds,
};

const container = d3.select('#graphic');
container.html('');

const mq = window.matchMedia('(min-width: 420px)');

let options;

const updateOptions = (opts, isSmall) => {
  if (mapParams && mapParams.lnglat) {
    opts.center = mapParams.lnglat;
    opts.initZoom = (isSmall) ? mapParams.z - 0.75 : mapParams.z;
  }
  return opts;
};

const handleBrowserSize = () => {
  if (mq.matches) {
    d3.select('#map').attr('style', 'width: 100%; height: 500px;');
    options = optionsLg;
    options = updateOptions(optionsLg, false);
  } else {
    d3.select('#map').attr('style', 'width: 100%; height: 300px;');
    options = optionsSm;
    options = updateOptions(optionsSm, true);
  }
};
handleBrowserSize();


const map = new mapboxgl.Map({
  container: 'map',
  style: MAP_ID,
  center: options.center,
  zoom: options.initZoom,
  maxZoom: options.maxZoom,
  minZoom: options.minZoom,
  bearing: 0,
  scrollZoom: true,
  dragRotate: false,
  logoPosition: 'bottom-right',
  touchPitch: false,
  interactive: true,
  projection: 'albers',
  maxBounds: options.mapBounds,
});

// disable map rotation using right click + drag
map.dragRotate.disable();

// disable map rotation using touch rotation gesture
map.touchZoomRotate.disableRotation();

const nav = new mapboxgl.NavigationControl({
  showCompass: false,
});
map.addControl(nav, 'top-right');


map.on('load', () => {
  d3.json('https://ix.cnn.io/data/wildfire-incidents/dissolved_evac_zones.geojson')
    .then((data) => {
      if (data.features && data.features.length > 0) {
        if (data.features[0].properties.last_update_eastern) {
          const timeStampFootnoote = d3.select('p#timestamp')
            .html(`Data last updated ${data.features[0].properties.last_update_eastern}`);
        }


        const isValidGeoJSON = data => data && data.type === 'FeatureCollection' && Array.isArray(data.features);

        // In the fetch
        if (isValidGeoJSON(data)) {
          // Proceed with adding the GeoJSON source and layer
        } else {
          console.error('Invalid GeoJSON structure:', data);
        }

        if (data.type !== 'FeatureCollection' || !Array.isArray(data.features)) {
          console.error('Invalid GeoJSON structure:', data);
          return;
        }

        map.addSource('evacuations', {
          type: 'geojson',
          data,
        });

        map.addLayer({
          id: 'evacuationsLayer',
          type: 'fill',
          source: 'evacuations',
          paint: {
            'fill-color': [
              'match',
              ['get', 'zone_status'],
              'Evacuation Warning', '#FFC41F',
              'Evacuation Order', '#FF6224',
              '#CCCCCC', // Default color if no match
            ],
            'fill-opacity': 0.3,
          },
        }, 'waterway-label');

        const { layers } = map.getStyle();

        // Log the names of all layers
        layers.forEach((layer) => {
          console.log(layer.id);
        });
      } else {
        console.error('No features found in current_evac_zones.geojson');
      }
    })
    .catch((error) => {
      console.error('Error fetching evacuation zones data:', error);
    });


  map.addSource('local-geojson', {
    type: 'geojson',
    data: geojsonData,
  });

  // Add the text label layer
  map.addLayer({
    id: 'label-layer',
    type: 'symbol',
    source: 'local-geojson',
    layout: {
      'text-field': ['get', 'Name'], // Use the "name" property for the label
      'text-font': ['CNN Sans Display Bold', 'Arial Unicode MS Bold'], // Specify fonts
      'text-size': 14, // Font size
      'text-offset': [1, -0.75], // Offset to position the text above the circle
      'text-anchor': ['get', 'TextAnchor'], // Anchor the text to the top of the point
      'text-letter-spacing': 0.03,
      'text-justify': 'left',
      'text-allow-overlap': true,
    },
    paint: {
      'text-color': '#000000', // Black text
    },
  });


  map.addSource('landmark-geojson', {
    type: 'geojson',
    data: 'https://ix.cnn.io/data/wildfire-incidents/landmarks.geojson',
  });

  map.addLayer({
    id: 'circle-layer',
    type: 'circle',
    source: 'landmark-geojson',
    paint: {
      'circle-radius': 2, // Circle size
      'circle-stroke-color': '#000000', // Black stroke
      'circle-stroke-width': 0, // Stroke thickness
      'circle-color': '#262626', // Transparent fill
    },
    filter: ['==', ['get', 'exclude'], false],
  });

  map.addLayer({
    id: 'landmark-label-layer',
    type: 'symbol',
    source: 'landmark-geojson',
    layout: {
      'text-field': ['get', 'name'], // Use the "name" property for the label
      'text-font': ['CNN Sans Display Regular', 'Arial Unicode MS Bold'], // Specify fonts
      'text-size': 12, // Font size
      'text-offset': [0.5, -0.25], // Offset to position the text above the circle
      'text-anchor': 'left', // Anchor the text to the top of the point
      'text-letter-spacing': 0.03,
      'text-justify': 'left',
    },
    paint: {
      'text-color': '#262626', // Black text
    },
    filter: ['==', ['get', 'exclude'], false],
  });

  map.on('move', () => {
    const center = map.getCenter();
    const zoom = map.getZoom();
    const bounds = map.getBounds(); // Get the map bounds

    console.log(`Zoom: ${zoom.toFixed(2)}, Center: [${center.lng.toFixed(5)}, ${center.lat.toFixed(5)}]`);
    console.log(`Bounds: SW [${bounds.getSouthWest().lng.toFixed(5)}, ${bounds.getSouthWest().lat.toFixed(5)}], NE [${bounds.getNorthEast().lng.toFixed(5)}, ${bounds.getNorthEast().lat.toFixed(5)}]`);
  });
});

let prevW = window.innerWidth;
const redraw = () => {
  if (!map || window.innerWidth === prevW) return;
  handleBrowserSize();
  map.setMaxBounds(options.mapBounds);
  map.setMaxZoom(options.maxZoom);
  map.setMinZoom(options.minZoom);
  map.setZoom(options.initZoom);
  map.setCenter(options.center);
  map.resize();
  prevW = window.innerWidth;
};
window.addEventListener('resize', redraw);
